import { render } from "./FormComponent.vue?vue&type=template&id=10e0b61a&scoped=true"
import script from "./FormComponent.vue?vue&type=script&lang=js"
export * from "./FormComponent.vue?vue&type=script&lang=js"

import "./FormComponent.vue?vue&type=style&index=0&id=10e0b61a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10e0b61a"]])

export default __exports__